import { useNavigate } from 'react-router-dom';
import { getRingCentralAuthUrl } from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import {
  useSmsConfigAccessControl,
  SmsConfigAction,
} from '../../../hooks/useSmsConfigAccessControl';

const AddRingCentralAccount = () => {
  const navigate = useNavigate();
  const getUrl = async () => {
    const response = await getRingCentralAuthUrl();
    navigate(response.data.url);
  };
  const { access, owns } = useSmsConfigAccessControl([SmsConfigAction.MANAGE_SMS_CONFIGURATION]);
  const [manageSmsConfig] = access;

  return (
    <WsButton onClick={getUrl} disabled={!(owns || manageSmsConfig)}>
      Add Ring Central Account
    </WsButton>
  );
};

export default AddRingCentralAccount;
